import { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ActiveTag, InactiveTag } from '../../../../svgIcons';
import Authorizer, { PERMISSIONS } from '../../../../session/authorizer';

class StudentsDataTable extends Component {
    gradeSectionBodyTemplate = (rowData) => {
        return `${rowData['custom:grade']}-${rowData.sectionName}`;
    };

    admissionCategoryBodyTemplate = (rowData) => {
        const { admissionCategories } = this.props;
        const admissionName = admissionCategories?.find(
            (admission) => admission?._id === rowData?.admissionCategory
        )?.categoryName;
        
        return <p>{admissionName}</p>;
    };

    statusBodyTemplate = (rowData) => {
        return rowData?.status === 'Active' ? <ActiveTag /> : <InactiveTag />;
    };

    changeStatusBodyTemplate = (rowData) => {
        const { onRaiseRequest } = this.props;
        
        return (
            <Authorizer permId={PERMISSIONS.RAISE_STUDENT_ADMISSION_CHANGE}>
                {rowData?.studentAdmissionChange !== 'INTRANSIT' ? (
                    <Button
                        className="addButtonn"
                        disabled={rowData?.status !== 'Active'}
                        onClick={() => onRaiseRequest(rowData)}
                    >
                        <p className="">Raise</p>
                    </Button>
                ) : (
                    <Button className="addButtonn" disabled>
                        <p>Request Raised</p>
                    </Button>
                )}
            </Authorizer>
        );
    };

    render() {
        const {
            users,
            lazyParams,
            totalRecords,
            onPage,
            onSort,
            onFilter
        } = this.props;

        return (
            <div className="card datatable-crud-demo ma-m30  m-2">
                <DataTable
                    ref={(el) => (this.dt = el)}
                    value={users}
                    dataKey="_id"
                    paginator
                    lazy
                    className="dataTableValuesText"
                    responsiveLayout="scroll"
                    showGridlines
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={onPage}
                    onSort={onSort}
                    onFilter={onFilter}
                    first={lazyParams.first}
                    rows={lazyParams.rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >
                    <Column 
                        style={{ width: '15rem', height: '6rem' }} 
                        alignHeader={'center'} 
                        headerClassName="text-color-secondary" 
                        bodyClassName="text-center" 
                        filterField="given_name" 
                        field="given_name" 
                        header="Student Name" 
                    />
                    <Column
                        style={{ width: '15rem', height: '6rem' }}
                        alignHeader={'center'}
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                        header="Admission Category"
                        body={this.admissionCategoryBodyTemplate}
                    />
                    <Column 
                        style={{ width: '15rem', height: '6rem' }} 
                        alignHeader={'center'} 
                        headerClassName="text-color-secondary" 
                        bodyClassName="text-center" 
                        filterField="branchId" 
                        field="branchName" 
                        header="Branch" 
                    />
                    <Column 
                        style={{ width: '15rem', height: '6rem' }} 
                        alignHeader={'center'} 
                        headerClassName="text-color-secondary" 
                        bodyClassName="text-center" 
                        filterField="custom:board" 
                        field="custom:board" 
                        header="Board" 
                    />
                    <Column
                        style={{ width: '15rem', height: '6rem' }}
                        alignHeader={'center'}
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                        filterField="custom:grade"
                        field="custom:grade"
                        body={this.gradeSectionBodyTemplate}
                        header="Grade-Section"
                    />
                    <Column 
                        style={{ width: '15rem', height: '6rem' }} 
                        alignHeader={'center'} 
                        headerClassName="text-color-secondary" 
                        bodyClassName="text-center" 
                        filterField="parentContactNo" 
                        field="parentContactNo" 
                        header="Phone Number" 
                    />
                    <Column
                        style={{ width: '15rem', height: '6rem' }}
                        alignHeader={'center'}
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                        header="Status"
                        body={this.statusBodyTemplate}
                    />
                    <Column
                        style={{ width: '15rem', height: '6rem' }}
                        alignHeader={'center'}
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                        header="Change Status"
                        body={this.changeStatusBodyTemplate}
                    />
                </DataTable>
            </div>
        );
    }
}

export default StudentsDataTable;
